export const CATEGORY_DETAILS_LOADED = "CATEGORY_DETAILS_LOADED";
export const CATEGORY_LOADED = "CATEGORY_LOADED";
export const CURATED_CATEGORY_TREATMENTS_LOADED =
  "CURATED_CATEGORY_TREATMENTS_LOADED";
export const SET_CATEGORY_ERROR = "SET_CATEGORY_ERROR";
export const CLEAR_CATEGORY_DETAILS = "CLEAR_CATEGORY_DETAILS";
export const CLEAR_CATEGORY_ERROR = "CLEAR_CATEGORY_ERROR";
export const CLEAR_CURATED_CATEGORY_TREATMENTS =
  "CLEAR_CURATED_CATEGORY_TREATMENTS";
